export class Rep {
  public repId: number
  public firstName: string
  public middleName: string
  public lastName: string
  public shortName: string
  public title: string
  public dob: Date
  public ssn: string
  public email: string
  public webAddress: string
  public insRepName: string
  public hireDate: Date
  public terminationDate: Date
  public crdnumber: string
  public branchNumber: string
  public brokerRep: boolean
  public bankRep: boolean
  public accessPerson: boolean
  public doNotPrint: boolean
  public notProducer: boolean
  public receiveAlerts: boolean
  public receiveApprovals: boolean
  public workAddress1: string
  public workAddress2: string
  public workCity: string
  public workState: string
  public workZip: string
  public mailAddress1: string
  public mailAddress2: string
  public mailCity: string
  public mailState: string
  public mailZip: string
  public homeAddress1: string
  public homeAddress2: string
  public homeCity: string
  public homeState: string
  public homeZip: string
  public workPhone: string
  public workExt: string
  public homePhone: string
  public mobilePhone: string
  public fax: string
  public adminFee: number
  public nasdannualFee: number
  public nasdbranchFee: number
  public active: boolean
  public hasUser: boolean

  constructor(cons: Partial<Rep>) {
    this.firstName = cons?.firstName
    this.middleName = cons?.middleName
    this.lastName = cons?.lastName
    this.shortName = cons?.shortName
    this.title = cons?.title
    this.dob = cons?.dob ? new Date(cons.dob) : null
    this.ssn = cons?.ssn
    this.email = cons?.email
    this.webAddress = cons?.webAddress
    this.insRepName = cons?.insRepName
    this.hireDate = cons?.hireDate ? new Date(cons.hireDate) : null
    this.terminationDate = cons?.terminationDate
      ? new Date(cons.terminationDate)
      : null
    this.crdnumber = cons?.crdnumber
    this.branchNumber = cons?.branchNumber
    this.brokerRep = cons?.brokerRep
    this.bankRep = cons?.bankRep
    this.accessPerson = cons?.accessPerson
    this.doNotPrint = cons?.doNotPrint
    this.notProducer = cons?.notProducer
    this.receiveAlerts = cons?.receiveAlerts
    this.receiveApprovals = cons?.receiveApprovals
    this.workAddress1 = cons?.workAddress1
    this.workAddress2 = cons?.workAddress2
    this.workCity = cons?.workCity
    this.workState = cons?.workState
    this.workZip = cons?.workZip
    this.mailAddress1 = cons?.mailAddress1
    this.mailAddress2 = cons?.mailAddress2
    this.mailCity = cons?.mailCity
    this.mailState = cons?.mailState
    this.mailZip = cons?.mailZip
    this.homeAddress1 = cons?.homeAddress1
    this.homeAddress2 = cons?.homeAddress2
    this.homeCity = cons?.homeCity
    this.homeState = cons?.homeState
    this.homeZip = cons?.homeZip
    this.workPhone = cons?.workPhone
    this.workExt = cons?.workExt
    this.homePhone = cons?.homePhone
    this.mobilePhone = cons?.mobilePhone
    this.fax = cons?.fax
    this.adminFee = cons?.adminFee
    this.nasdannualFee = cons?.nasdannualFee
    this.nasdbranchFee = cons?.nasdbranchFee
    this.active = cons?.active
    this.repId = cons?.repId ? cons.repId : 0
    this.hasUser = cons?.hasUser
  }
}

export class Lookups {
  public orderedCrdBranchNumbers: Array<string> = []
  public stateList: Array<any> = []
}

export class Assistant {
  repId: number
  active: boolean
  assistantEmail: string
  assistantEndDate: Date
  assistantId: number
  assistantName: string
  assistantStartDate: Date
  asstReg: boolean
  fingerPrintReceived: boolean
  fingerPrintRequired: boolean
  hasWebAccess: boolean
  infoLevel: string
  infoLevelId: string
  receiveAlerts: boolean
  receiveApprovals: boolean
  phoneNumber: string
  userRole:string

  constructor(cons: Partial<Assistant>) {
    this.repId = cons?.repId
    this.active = cons?.active
    this.assistantEmail = cons?.assistantEmail
    this.assistantEndDate = cons?.assistantEndDate
      ? new Date(cons.assistantEndDate)
      : null
    this.assistantId = cons?.assistantId ? cons.assistantId : 0
    this.assistantName = cons?.assistantName
    this.assistantStartDate = cons?.assistantStartDate
      ? new Date(cons.assistantStartDate)
      : null
    this.asstReg = cons?.asstReg
    this.fingerPrintReceived = cons?.fingerPrintReceived
    this.fingerPrintRequired = cons?.fingerPrintRequired
    this.hasWebAccess = cons?.hasWebAccess
    this.infoLevel = cons?.infoLevel
    this.infoLevelId = cons?.infoLevelId
    this.receiveAlerts = cons?.receiveAlerts
    this.receiveApprovals = cons?.receiveApprovals
    this.phoneNumber = cons?.phoneNumber
    this.userRole = cons?.userRole
  }
}

export class BdState {
  active: boolean
  bdfees: number
  repBDStateID: number
  repId: number
  state: string
  stateText: string

  constructor(cons: Partial<BdState>) {
    this.active = cons?.active
    this.bdfees = cons?.bdfees
    this.repBDStateID = cons?.repBDStateID ? cons.repBDStateID : 0
    this.repId = cons?.repId
    this.state = cons?.state
    this.stateText = cons?.stateText
  }
}

export class IaState {
  active: boolean
  iafees: number
  repIAStateID: number
  repId: number
  state: string
  stateText: string

  constructor(cons: Partial<IaState>) {
    this.active = cons?.active
    this.iafees = cons?.iafees
    this.repIAStateID = cons?.repIAStateID ? cons.repIAStateID : 0
    this.repId = cons?.repId
    this.state = cons?.state
    this.stateText = cons?.stateText
  }
}

export class RepLicense {
  active: boolean
  licenseID: number
  licenseType: string
  repID: number
  repLicenseID: number

  constructor(cons: Partial<RepLicense>) {
    this.active = cons?.active
    this.licenseID = cons?.licenseID
    this.licenseType = cons?.licenseType
    this.repID = cons?.repID
    this.repLicenseID = cons?.repLicenseID ? cons.repLicenseID : 0
  }
}

export class Note {
  noteId: number
  rep: number
  entryDate: Date
  noteTypeId: number
  noteType: string
  noteMemo: string
  followup: boolean

  constructor(cons: Partial<Note>) {
    this.noteId = cons?.noteId ? cons.noteId : 0
    this.rep = cons?.rep
    this.entryDate = cons?.entryDate ? new Date(cons.entryDate) : null
    this.noteTypeId = cons?.noteTypeId
    this.noteType = cons?.noteType
    this.noteMemo = cons?.noteMemo
    this.followup = cons?.followup
  }
}

export class PersonalAccount {
  outsideAccountId: number
  repId: number
  custodian: string
  accountNumber: string
  accountTitle: string
  relationship: string
  startDate: Date
  endDate: Date
  active: boolean

  constructor(cons: Partial<PersonalAccount>) {
    this.outsideAccountId = cons?.outsideAccountId ? cons.outsideAccountId : 0
    this.repId = cons?.repId
    this.custodian = cons?.custodian
    this.accountNumber = cons?.accountNumber
    this.accountTitle = cons?.accountTitle
    this.relationship = cons?.relationship
    this.startDate = cons?.startDate ? new Date(cons.startDate) : null
    this.endDate = cons?.endDate ? new Date(cons.endDate) : null
    this.active = cons?.active
  }
}

export class OutsideActivity {
  outsideActivityId: number
  repId: number
  businessName: string
  role: string
  description: string
  outsideIa: boolean
  outsideIns: boolean
  beginDate: Date
  endDate: Date
  active: boolean

  constructor(cons: Partial<OutsideActivity>) {
    this.outsideActivityId = cons?.outsideActivityId
      ? cons.outsideActivityId
      : 0
    this.repId = cons?.repId
    this.businessName = cons?.businessName
    this.role = cons?.role
    this.description = cons?.description
    this.outsideIa = cons?.outsideIa
    this.outsideIns = cons?.outsideIns
    this.beginDate = cons?.beginDate ? new Date(cons.beginDate) : null
    this.endDate = cons?.endDate ? new Date(cons.endDate) : null
    this.active = cons?.active
  }
}

export class RepPro {
  repProId: number
  repId: number
  proTypeId: number
  proTypeString: string
  active: boolean

  constructor(cons: Partial<RepPro>) {
    this.repProId = cons?.repProId ? cons.repProId : 0
    this.repId = cons?.repId
    this.proTypeId = cons?.proTypeId
    this.proTypeString = cons?.proTypeString
    this.active = cons?.active
  }
}

export class RepFirm {
  repFirmID: number
  repID: number
  firmTypeID: number
  firmTypeDescription: string
  active: boolean

  constructor(cons: Partial<RepFirm>) {
    this.repFirmID = cons?.repFirmID ? cons.repFirmID : 0
    this.repID = cons?.repID
    this.firmTypeID = cons?.firmTypeID
    this.firmTypeDescription = cons?.firmTypeDescription
    this.active = cons?.active
  }
}

export class RepCode {
  repCodeId: number
  repID: number
  repCode: string
  repTitle: string
  repType: string
  startDate: Date
  endDate: Date
  bankRep: boolean
  active: boolean

  constructor(cons: Partial<RepCode>) {
    this.repCodeId = cons?.repCodeId ? cons.repCodeId : 0
    this.repID = cons?.repID
    this.repCode = cons?.repCode
    this.repTitle = cons?.repTitle
    this.repType = cons?.repType
    this.startDate = cons?.startDate ? new Date(cons.startDate) : null
    this.endDate = cons?.endDate ? new Date(cons.endDate) : null
    this.bankRep = cons?.bankRep
    this.active = cons?.active
  }
}

export class RepSocialMedia {
  repSocialMediaID: number
  repID: number
  approvedSocialMediaID: number
  socialMedia: string
  accountName: string
  startDate: Date
  endDate: Date

  constructor(cons: Partial<RepSocialMedia>) {
    this.repSocialMediaID = cons?.repSocialMediaID ? cons.repSocialMediaID : 0
    this.repID = cons?.repID
    this.approvedSocialMediaID = cons?.approvedSocialMediaID
    this.socialMedia = cons?.socialMedia
    this.accountName = cons?.accountName
    this.startDate = cons?.startDate ? new Date(cons.startDate) : null
    this.endDate = cons?.endDate ? new Date(cons.endDate) : null
  }
}

export class Solicitor {
  solicitorId: number
  firmTypeLookup: number
  firmType: string
  repId: number
  solicitorDescription: string
  startDate: Date
  endDate: Date
  fileLocation: string
  active: boolean

  constructor(cons: Partial<Solicitor>) {
    this.solicitorId = cons?.solicitorId ? cons.solicitorId : 0
    this.firmTypeLookup = cons?.firmTypeLookup
    this.firmType = cons?.firmType
    this.repId = cons?.repId
    this.solicitorDescription = cons?.solicitorDescription
    this.startDate = cons?.startDate ? new Date(cons.startDate) : null
    this.endDate = cons?.endDate ? new Date(cons.endDate) : null
    this.fileLocation = cons?.fileLocation
    this.active = cons?.active
  }
}

export class RepSubscription {
  repSubscriptionID: number
  repID: number
  subscriptionID: number
  subscriptionDescription: string
  cost: number
  userID: string
  active: boolean

  constructor(cons: Partial<RepSubscription>) {
    this.repSubscriptionID = cons?.repSubscriptionID
      ? cons.repSubscriptionID
      : 0
    this.repID = cons?.repID
    this.subscriptionID = cons?.subscriptionID
    this.subscriptionDescription = cons?.subscriptionDescription
    this.cost = cons?.cost
    this.userID = cons?.userID
    this.active = cons?.active
  }
}
